import Containers from "./containers";
import Hero from "./hero";
import OurAdvantages from "./ourAdvantages";
import OurVision from "./ourVision";
import Features from "./Features/Features";
import Shipping from "./shipping";
import OurServices from "./ourServices/ourServices";
import MeetOutTeam from "../../pages/aboutUs/meetOurTeam";
import WhyUs from "./whyUs";

const Home = () => {
  return (
    <div>
      <Hero />
      <Features />
      <OurVision />
      <OurAdvantages />
      <Shipping />
      <Containers />
      <OurServices />
      <MeetOutTeam />
      <WhyUs />
    </div>
  );
};

export default Home;
